import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

const Ourreach = () => {
   const { ref: sectionRef, inView: sectionInView } = useInView({
    triggerOnce: true,
    threshold: 0.2, // Start animation when 20% of the section is visible
  });


  const globeRef = useRef(null);
  const [isRevealed, setIsRevealed] = useState({
    topRight: false,
    bottomRight: false,
  });

  const handleScroll = () => {
    const topRightElement = document.querySelector('.topright');
    const bottomRightElement = document.querySelector('.bottomright');

    const topRightRect = topRightElement.getBoundingClientRect();
    const bottomRightRect = bottomRightElement.getBoundingClientRect();

    if (topRightRect.top < window.innerHeight && !isRevealed.topRight) {
      setIsRevealed({ ...isRevealed, topRight: true });
      setIsRevealed({ ...isRevealed, topRight: true });
      if (globeRef.current) {
        globeRef.current.style.scale = '1';
        globeRef.current.style.opacity = '1';
        setTimeout(() => {
        }, 650);
      }
    }

    if (bottomRightRect.top > window.innerHeight && isRevealed.topRight) {
      setIsRevealed({ ...isRevealed, topRight: false });
      if (globeRef.current) {
        globeRef.current.style.scale = '0';
        globeRef.current.style.opacity = '0';
      }
    }
  };


  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevealed]);

  return (
    <section className="our-reach-section" ref={sectionRef}>
      <div className="heading-container">
        <h1 className={sectionInView ? "heading-animated-reveal is-in-view" : "heading-animated-reveal"}>
          {"OUR REACH".split("").map((char, index) => (
            <span key={index} style={{ transitionDelay: `${index * 0.05}s` }}>
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </h1>
      </div>
      <div className="container-wrapper">
        <div className="Ourreach-container">
          {/* <div
            id="enhanced-center-line"
            style={{ height: lineHeight }}
          ></div> */}
          <div className="enhanced-top enhanced-left enhanced-reveal">
            <div className="enhanced-feature enhanced-round-top-left enhanced-round-bottom-right">
              <div className="enhanced-img-wrapper">
                <img src="assets/Our_Reach/6.jpg" alt="Members" />
              </div>
              <div className="enhanced-feature-text enhanced-text-left">
                <span className="enhanced-stats-h1">100+</span>
                <span className="enhanced-stats-h2">Mentors</span>
              </div>
            </div>
          </div>
          <div className="enhanced-top enhanced-right enhanced-reveal topright">
            <div className="enhanced-feature enhanced-round-top-right enhanced-round-bottom-left">
              <div className="enhanced-feature-text enhanced-text-right">
                <span className="enhanced-stats-h1">450+</span>
                <span className="enhanced-stats-h2">Activities</span>
              </div>
              <div className="enhanced-img-wrapper">
                <img src="assets/Our_Reach/7.jpg" alt="Activities" />
              </div>
            </div>
          </div>
          <div className="enhanced-center" ref={globeRef}>  
            <div className="enhanced-main-img">
              <img src="assets/img/whyjoin/abcd.jpg" alt="Center" />
            </div>
          </div>
          <div className="enhanced-bottom enhanced-left enhanced-reveal">
            <div className="enhanced-feature enhanced-round-top-right enhanced-round-bottom-left">
              <div className="enhanced-img-wrapper">
                <img src="assets/Our_Reach/4.jpg" alt="Colleges" />
              </div>
              <div className="enhanced-feature-text enhanced-text-left">
                <span className="enhanced-stats-h1">50+</span>
                <span className="enhanced-stats-h2">Colleges</span>
              </div>
            </div>
          </div>
          <div className="enhanced-bottom enhanced-right enhanced-reveal bottomright">
            <div className="enhanced-feature enhanced-round-top-left enhanced-round-bottom-right">
              <div className="enhanced-feature-text enhanced-text-right">
                <span className="enhanced-stats-h1">11000+</span>
                <span className="enhanced-stats-h2">Volunteers</span>
              </div>
              <div className="enhanced-img-wrapper">
                <img src="assets/Our_Reach/5.jpg" alt="Volunteers" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`button-container ${sectionInView ? 'is-visible' : ''}`}>
        <a
          href="/campus-ambassador"
          target="_blank"
          rel="noopener noreferrer"
          className="reach-btn btn-primary"
        >
          AMBASSADOR
        </a>
        <Link to="/residential-facilities" className="reach-btn btn-secondary">
          Residential Facilities
        </Link>
      </div>
    </section>
  );
};

export default Ourreach;